import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
export const snapshot = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

snapshot.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/extraction/snapshot',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
snapshot.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return snapshot.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
snapshot.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
snapshot.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: snapshot.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
const snapshotForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
snapshotForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExtractionSnapshotController::snapshot
* @see Http/Controllers/ExtractionSnapshotController.php:30
* @route '/projects/{project}/extraction/snapshot'
*/
snapshotForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: snapshot.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

snapshot.form = snapshotForm

const extraction = {
    snapshot: Object.assign(snapshot, snapshot),
}

export default extraction